'use client';

function handleAriaDescribedBy({ error, caption }, descriptionId, { "aria-describedby": other = "" }) {
  const hasDescription = !!error || !!caption;
  if (!hasDescription && !other) return {};
  const description = hasDescription ? descriptionId : "";
  const spaceIfNeeded = description && other ? " " : "";
  return {
    "aria-describedby": `${description}${spaceIfNeeded}${other}`
  };
}
export {
  handleAriaDescribedBy
};
